import type { ReactNode } from 'react';
import { usePlatformMe } from './hooks';
import { SettingsAccessDenied } from '@/components/layout/SettingsAccessDenied';
import { Skeleton } from '@/components/ui/skeleton';
import { ApiError } from '@/lib/api';

/**
 * Confirms the user is on the platform admin allowlist via GET /api/v1/platform/me.
 */
export function InternalAdminGuard({ children }: { children: ReactNode }) {
  const { data, isLoading, isError, error } = usePlatformMe();

  if (isLoading) {
    return (
      <div className="space-y-4 p-6">
        <Skeleton className="h-10 w-64" />
        <Skeleton className="h-64 w-full" />
      </div>
    );
  }

  if (isError || !data) {
    if (error instanceof ApiError && error.status === 403) {
      return <SettingsAccessDenied />;
    }
    return (
      <div className="p-6">
        <p className="text-muted-foreground">Unable to verify platform admin access.</p>
      </div>
    );
  }

  return <>{children}</>;
}
